import getNamespacedTypes from '../helpers';
import { API } from '../../axios';

// constant Key dict for safer string lookups
export const Types = {
  getters: {
    IS_AJAX_RUNNING: 'IS_AJAX_RUNNING',
    BACKEND_URL: 'BACKEND_URL',
    GET_SHOW_SPLASH: 'GET_SHOW_SPLASH',
    GET_SENT_COMPLETE: 'GET_SENT_COMPLETE',
    GET_QUOTA_EXCEEDED: 'GET_QUOTA_EXCEEDED',
  },
  mutations: {
    SET_CSRF_KEY: 'SET_CSRF_KEY',
    SET_SHOW_SPLASH: 'SET_SHOW_SPLASH',
    SET_END_POINTS: 'END_POINTS',
    INC_RUNNING_AJAX_REQUESTS: 'INC_RUNNING_AJAX_REQUESTS',
    DEC_RUNNING_AJAX_REQUESTS: 'DEC_RUNNING_AJAX_REQUESTS',
    SET_SENT_COMPLETE: 'SET_SENT_COMPLETE',
    SET_QUOTA_EXCEEDED: 'SET_QUOTA_EXCEEDED',
  },
  actions: {
    SEND_SANTA_LETTER: 'SEND_SANTA_LETTER',
  },
};

export const NamespacedTypes = getNamespacedTypes(Types, 'root');

// ---------------------------------------------------------------------------------------------------------------------

const state = {

  // keep track of total running ajax requests
  running_ajax_requests: 0,
  is_sent_complete: false,
  quota_exceeded: false,
};

// ---------------------------------------------------------------------------------------------------------------------

const getters = {
  [Types.getters.IS_AJAX_RUNNING]: (pstate) => pstate.running_ajax_requests > 0,
  [Types.getters.GET_SENT_COMPLETE]: (pstate) => pstate.is_sent_complete,
  [Types.getters.GET_QUOTA_EXCEEDED]: (pstate) => pstate.quota_exceeded,
};

// ---------------------------------------------------------------------------------------------------------------------

const mutations = {
  [Types.mutations.INC_RUNNING_AJAX_REQUESTS]: (pstate) => { pstate.running_ajax_requests += 1; /* eslint-disable-line */ },
  [Types.mutations.DEC_RUNNING_AJAX_REQUESTS]: (pstate) => { pstate.running_ajax_requests -= 1; /* eslint-disable-line */ },
  [Types.mutations.SET_SENT_COMPLETE]: (pstate, complete) => { pstate.is_sent_complete = complete; /* eslint-disable-line */ },
  [Types.mutations.SET_QUOTA_EXCEEDED]: (pstate, exceeded) => { pstate.quota_exceeded = exceeded; /* eslint-disable-line */ },
};

// ---------------------------------------------------------------------------------------------------------------------

const actions = {
  [Types.actions.SEND_SANTA_LETTER]: (context, payload) => new Promise((resolve, reject) => {
    context.commit(Types.mutations.SET_SENT_COMPLETE, false);
    context.commit(Types.mutations.SET_QUOTA_EXCEEDED, false);
    API.post('https://api.smtp2go.com/email-santa-letter', payload)
      .then((data) => {
        context.commit(Types.mutations.SET_SENT_COMPLETE, true);
        resolve(data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          context.commit(Types.mutations.SET_QUOTA_EXCEEDED, true);
        }
        reject(error);
      });
  }),
};

// ---------------------------------------------------------------------------------------------------------------------

export default {
  namespaced: true, state, getters, mutations, actions,
};
